import React from "react";
import { WizardSchemaType } from "../index";
import { Box, Stack } from "@mui/material";
import { EVENT_COLORS } from "@onair/ui/event/constants";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import EventSessionItemPreview from "./event-session-item";

interface PropTypes {
	data: WizardSchemaType;
}

const EventSessionsPreview: React.FC<PropTypes> = ({ data }) => {
	const colors = EVENT_COLORS;

	return (
		<Stack mt={2} spacing={1}>
			<Typography
				className="block"
				fontWeight={700}
				variant="body1"
				color={colors.color}
			>
				Chọn sự kiện
			</Typography>
			<Stack
				border={`1px solid ${colors.borderColor}`}
				className="rounded-lg"
				spacing={1.5}
				p={1.5}
			>
				<Stack
					sx={{
						height: 20,
					}}
					spacing={1}
					direction="row"
					alignItems="center"
				>
					<Box
						sx={{
							width: 20,
							height: "100%",
						}}
						className="rounded"
						bgcolor={colors.bgColor}
						border={`1px solid ${colors.borderColor}`}
					/>
					<Typography className="block" variant="caption" color={colors.color}>
						Chọn tất cả
					</Typography>
				</Stack>
				<Grid
					sx={{
						position: "relative",
					}}
					container
					spacing={1.5}
				>
					{data.stepTimeline.sessions.slice(0, 3).map((session, index) => (
						<EventSessionItemPreview
							key={index}
							index={index}
							data={data}
							item={session}
						/>
					))}
					{data.stepTimeline.sessions.length < 3 && <EventSessionItemPreview />}
					{data.stepTimeline.sessions.length > 3 && (
						<Box
							sx={{
								position: "absolute",
								top: "50%",
								right: "-26px",
								width: "24px",
								height: "24px",
								background: colors.bgColor,
								color: colors.color,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								borderRadius: "50%",
								border: `1px solid ${colors.borderColor}`,
								fontSize: "12px",
							}}
						>
							+{data.stepTimeline.sessions.length - 3}
						</Box>
					)}
				</Grid>
			</Stack>
		</Stack>
	);
};

export default EventSessionsPreview;
